import { render, staticRenderFns } from "./CreateNewClass.vue?vue&type=template&id=40fdab5e&scoped=true&"
import script from "./CreateNewClass.vue?vue&type=script&lang=js&"
export * from "./CreateNewClass.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewClass.vue?vue&type=style&index=0&id=40fdab5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fdab5e",
  null
  
)

export default component.exports